<template>
    <div class="tw-flex tw-flex-col tw-w-full">
        <hr class="mt-0 mb-4 border-dark-grey w-full">

        <!-- General Section -->
        <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <div class="tw-w-full lg:tw-w-1/6">
                <div class="uppercase pb-2 tw-text-sm">GENERAL</div>
            </div>
            <div class="tw-w-full lg:tw-w-3/4">
                <h3 class="uppercase pb-4">BENEFITS</h3>
                <div class="tw-text-sm tw-font-light tw-pb-3">
                    <p>When working under an IATSE Local 667 collective agreement, members will receive a variety of
                        benefits dependent upon the individual production agreement negotiated with IATSE 667.
                        Production remits the cost of these benefits to the Local who then administers the allocation of
                        funds to the applicable plans.</p>
                    <p>Based on the current collective agreement, the health and welfare benefits paid by producers
                        could be a maximum of 4.5% and $12 per day plus any applicable provincial sales taxes. The RRSP benefit could be a maximum
                        of 7% while vacation pay can be anywhere from 4% to the maximum of 8%. The health and welfare
                        and RRSP benefits percentage is calculated based upon the total of the gross wages plus vacation
                        pay.</p>
                    <p>For details on the Benefit plans, please see below. For questions regarding the plan, please
                        contact the Benefits Coordinator, Mary Miskic, via the local office.</p>

                </div>
                <v-expansion-panels
                    accordion
                    flat
                >
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <template v-slot:default="{ open }">

                                <div class="tw-flex tw-flex-row tw-justify-between tw-align-middle tw-border-t tw-border-dark-grey tw-py-2">
                                    <div class="tw-text-2xl tw-mt-1">Health & Welfare</div>
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </div>

                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="tw-text-sm tw-font-light tw-pb-3">
                                As a function of the Local’s collective agreement, benefits for Health and Welfare are negotiated on your behalf.
                                Currently there are two Health and Welfare Benefits – a percentage amount and a dollar amount.
                                The percentage amount contributed is based on the gross pay (gross wage plus vacation pay) received per production contract.
                                The dollar amount is an additional flat contribution per day worked under an agreement.<br><br>
                                The producer health and welfare contributions will be allocated to your individual health and welfare account to be used to purchase insurance and counseling benefits.<br><br>
                                The amount of producer contributions received during the calendar year determines your benefit level coverage. The benefit year begins April 1st of the following year and could include medical care, dental care, vision care and short term disability benefits.<br><br>
                                These benefits are held in trust through the IATSE Local 667/669 Health and Welfare Trust, governed by trustees from each local.  For further information on the health and welfare benefits for members and eligible family members or to download claim forms visit the <a href="https://www.iatse667-669healthplan.com" target="_blank">IATSE Local 667/669 Health and Welfare Benefits</a> website.<br><br>
                                Visit the <a href="https://my.canadalife.com/register" target="_blank">Canada Life</a>  website to create a profile, review your claims history and make online claims directly deposited to your registered bank account.<br><br>
                                What happens if I work outside of the I.A.T.S.E. Local 667 jurisdiction and collective agreement?<br><br>
                                1.	When working in Local 669's jurisdiction and under the Local 669 collective agreement:
                                I.A.T.S.E. Local 669 is a partner with Local 667 in the National I.A.T.S.E. Local 667/669 Health and Welfare Benefit Plan. Any health and welfare contributions earned in Local 669's jurisdiction under their collective agreement will be forwarded to the National Health & Welfare administration office and allocated to your individual account.<br><br>
                                2.	If working outside either the Local 667 or Local 669 collective agreements:
                                Usually the producer will not remit any health and welfare benefits. On an annual basis, members in good standing are provided with the option of purchasing better benefits in the event that they have not received enough remittances for benefit coverage. Please refer to your Member Benefit Booklet or visit the Health and Welfare Benefit Plan web site for further information.<br>


                                <hr class="mt-0 mb-4 border-dark-grey w-full">

                                <div class="uppercase pb-2 tw-text-sm">MEMBER ASSISTANCE PROGRAM</div>
                                Confidential information, counseling and referral services are available to you and your eligible family members. These services are provided through the Member and Family Assistance Program (MAP) by Telus Health, formerly Lifeworks.<br>
                                Confidential assistance is available for a broad range of personal or work-related concerns which may affect you or your family such as:<br>
                                <hr class="mt-0 mb-4 border-dark-grey w-full">
                                (1) 	personal and/or job stress
                                <hr class="mt-0 mb-4 border-dark-grey w-full">
                                (2) 	relationship issues, eldercare and childcare
                                <hr class="mt-0 mb-4 border-dark-grey w-full">
                                (3) 	addictions
                                <hr class="mt-0 mb-4 border-dark-grey w-full">
                                (4) 	parenting and adolescent issues
                                <hr class="mt-0 mb-4 border-dark-grey w-full">
                                (5) 	financial or legal concerns
                                <hr class="mt-0 mb-4 border-dark-grey w-full">

                                The <a href="https://www.iatse667-669healthplan.com/family-services/" target="_blank">MAP</a> is one of the benefits provided by the Health and Welfare Plan. There is no additional cost to you or covered family members to use this program regardless of your benefit level.<br><br>

                                <b>For immediate access to specially trained counselors 24/7/365, call <a href="tel:1-800-387-4765">1-800-387-4765</a></b>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>


                <v-expansion-panels
                    accordion
                    flat
                >
                    <v-expansion-panel>
                        <v-expansion-panel-header hide-actions>
                            <template v-slot:default="{ open }">

                                <div class="tw-flex tw-flex-row tw-justify-between tw-align-middle tw-border-t tw-border-dark-grey tw-py-2">
                                    <div class="tw-text-2xl tw-mt-1">Retirement Benefits</div>
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </div>

                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="tw-text-sm tw-font-light tw-pb-3">
                                CANADIAN ENTERTAINMENT INDUSTRY RETIREMENT PLAN (CEIRP) <a href="https://www.ceirp.ca/en/" target="_blank"> www.ceirp.ca </a><br><br>
                                As a function of the Local’s collective agreement, benefits for a group retirement plan are negotiated on your behalf.  Currently, there are two RRSP Benefit contributions – a percentage amount and a dollar amount.  The percentage amount contributed is based on the gross pay (gross wage plus vacation pay) received per production contract.  The dollar amount is an additional flat contribution per day worked under an agreement.<br><br>
                                The producer will pay you the negotiated RRSP percentage and the daily dollar amount, based on your gross wages plus vacation pay. Because your RRSP is a taxable benefit, these contributions must be included on your pay-cheque as income.<br><br>
                                The production’s payroll company will make the required government remittances after which the group RRSP benefit will be deducted from your pay-cheque and forwarded to the plan administrator in the I.A.T.S.E. Local 667 office. After confirming the accuracy and allocation of these monies, the funds will be remitted to your account with our provider, Canada Life.<br><br>
                                Visit the site at <a href="https://ssl.grsaccess.com/information/english/aboutgrs/" target="_blank">www.grsaccess.com</a><br><br>
                                <b>How do I sign up with Canada Life?</b><br>
                                You can sign up with Canada Life by requesting an application package from the I.A.T.S.E. Local 667 office and returning the completed forms to the attention of the plan administrator in the Local 667 office.<br>
                                <b>Is it mandatory that I sign up with Canada Life?</b><br>
                                Yes, it is mandatory that all members sign up with Canada Life. Even if you have your own RRSP elsewhere, any RRSP remittances received through the collective agreement will be forwarded to your account at Canada Life. You must maintain this account with Canada Life as long as you remain a member of I.A.T.S.E.<br>
                                <b>What happens if I am incorporated?</b><br>
                                Even if you are incorporated, it is mandatory that you sign up with Canada Life.<br>
                                <b>I don't have time to communicate with the Canada Life investment counsellors, what should I do in the meantime?</b><br>
                                If you are pressed for time, you still must sign up with Canada Life for an account. If you do not choose an investment option it will automatically default to the Cadence fund until such time as you can communicate with a Canada Life investment counsellor to determine your investment strategy.<br>
                                <b>What happens if I work outside of the I.A.T.S.E. Local 667 jurisdiction and / or Collective Agreement?</b><br>
                                If you work in the jurisdiction of a participating I.A.T.S.E. Local or Directors Guild, the Plan Administrator will ensure your RRSP benefit is forwarded to your account at Canada Life.<br>

                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <hr class="mt-0 mb-4 border-dark-grey w-full">

        <!-- Contributions Section -->
        <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <div class="tw-w-full lg:tw-w-1/6 h7 tw-pb-2"></div>
            <div class="tw-w-full lg:tw-w-3/4">
                <h3 class="uppercase pb-4">CONTRIBUTIONS</h3>
                <div class="tw-text-sm tw-font-light tw-pb-3">
                    Remittances can arrive up to 2 weeks after you have worked
                </div>
            </div>
        </div>
        <div class="tw-flex tw-justify-between mb-4">
            <v-radio-group v-model="nameOrYear" row>
                <v-radio label="By year" :value="1"/>
                <v-radio label="By production" :value="0"/>
            </v-radio-group>

            <div class="mt-4">
                <v-btn @click="exportContributionsModal = !exportContributionsModal" class="main-btn">
                    Export
                </v-btn>
            </div>
<!--            <div>-->
<!--                <date-picker-->
<!--                    v-model="filters.period_ending"-->
<!--                    :yearOnly="true"-->
<!--                    min="2000"-->
<!--                    :max="`${new Date().getFullYear() }`"-->
<!--                    clearable-->
<!--                    dense-->
<!--                    color="primary"-->
<!--                    label="Filter Year"-->
<!--                    display-label="Filter Year"-->
<!--                    ref="dateDepositPicker"-->
<!--                    hide-details="auto"-->
<!--                />-->
<!--            </div>-->
        </div>

        <smart-table
            ref="table_productions"
            endpoint="memberdataexcel.list"
            :headers="headers"
            :items-per-page="100"
            item-key="member_data_excels_id"
            :options_payload="{is_contributions:true, group_by:groupByValue}"
            class="row-pointer"
            :options="{itemsPerPage:[-1]}"
            :group-by="groupByValue"
        >
            <template v-slot:group="{ group, items }">
                <tr>
                    <td :colspan="headers.length -1" class="production">
                        <strong>{{ group }}</strong>
                    </td>
                </tr>

                <tr v-for="item in items" :key="item.member_data_excels_id">
                    <template v-if="nameOrYear === 0">
                        <td v-for="header in headers.slice(1)" :key="header.value" class="data-center">
                            <template v-if="header.value !== 'user_id'">
                                <template v-if="header.value === 'hw_real_total_calc' || header.value === 'hw_net_calc'">
                                    {{ Number(item[header.value])?.toFixed(2) }}
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </template>
                        </td>
                    </template>
                    <template v-else>
                        <td v-for="header in headers" :key="header.value" class="data-center">
                            <template v-if="header.value !== 'user_id'">
                                <template v-if="header.value === 'production.name'">
                                    {{ item.production_name }}
                                </template>
                                <template v-if="header.value === 'hw_real_total_calc' || header.value === 'hw_net_calc'">
                                    {{ Number(item[header.value])?.toFixed(2) }}
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </template>
                        </td>
                    </template>
                </tr>

                <template v-if="nameOrYear === 0">
                    <tr class="total">
                        <td colspan="1">
                            Total:
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('rrsp_daily', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('pension', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('pension_deducted_employee', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_daily', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_employer', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_employee', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('hw_real_total_calc', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('hw_net_calc', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('dues_amount', items) }}
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr class="total">
                        <td colspan="1">
                            Total:
                        </td>
                        <td colspan="1">
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('rrsp_daily', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('pension', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('pension_deducted_employee', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_daily', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_employer', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('HW_employee', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('hw_real_total_calc', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('hw_net_calc', items) }}
                        </td>
                        <td colspan="1" class="data-center">
                            {{ calculateTotal('dues_amount', items) }}
                        </td>
                    </tr>
                </template>
            </template>

            <template v-slot:item.period_ending="{ isMobile, item, header, value, index}">
                <div>{{ $root.getAsIsoDate(value) }}</div>
            </template>

        </smart-table>


        <export-contributions-modal
            v-model="exportContributionsModal"
            :filters="generateFiltersWithSearch()"
            :group_by="groupByValue"
        ></export-contributions-modal>
    </div>
</template>

<script>
import SmartTable from "@/Generic/SmartTable";
import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav";
import DatePicker from "@/Generic/DatePicker.vue";
import ExportContributionsModal from "@/Modals/ExportContributionsModal";

export default {
    name: "BenefitsContributionsIndex",
    layout: (h, page) => {
        return h(AppLayoutSidebarNav, [
            page
        ])
    },
    components: {
        SmartTable,
        DatePicker,
        ExportContributionsModal,
    },
    props: {
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            member: this.input,
            search: null,
            filters: {},
            exportContributionsModal: false,
            nameOrYear: 1,
        }
    },
    computed: {
        headers() {
            return [
                { value: 'production.name',   text: 'Production',        align: this.nameOrYear === 1 ? 'center' : ' d-none',  sortable: false,    filterable: false },
                { value: 'period_ending',     text: 'Period Ending',     align: 'center',   sortable: true,     filterable: true, search: this.filters.period_ending },
                { value: 'rrsp_daily',        text: 'RRSP - Daily',      align: 'center',   sortable: true,     filterable: false },
                { value: 'pension',           text: 'RRSP - Employer',   align: 'center',   sortable: true,     filterable: false },
                { value: 'pension_deducted_employee', text: 'RRSP - Voluntary',  align: 'center',   sortable: true,     filterable: false },
                { value: 'HW_daily',          text: 'H&W - Daily',       align: 'center',   sortable: true,     filterable: false },
                { value: 'HW_employer',       text: 'H&W - Employer',    align: 'center',   sortable: true,     filterable: false },
                { value: 'HW_employee',       text: 'H&W - Employee',    align: 'center',   sortable: true,     filterable: false },
                { value: 'hw_real_total_calc',text: 'H&W - Total',       align: 'center',   sortable: false,    filterable: false },
                { value: 'hw_net_calc',       text: 'H&W - Net',         align: 'center',   sortable: false,    filterable: false },
                { value: 'dues_amount',       text: 'Working Dues',      align: 'center',   sortable: false,    filterable: false },
                { value: 'user_id',           text: 'User',              align: ` d-none`,  sortable: true,     filterable: true,     search: this.member.id },
            ];
        },
        groupByValue() {
            return this.nameOrYear ? 'year' : 'production_name'
        },
    },
    methods: {
        calculateTotal(columnName, items) {
            let total = 0.0
            for (const item of items) {
                    total += parseFloat(item[columnName] || 0)
            }
            return total?.toFixed(2)
        },
        generateFiltersWithSearch() {
            let filtersWithSearch = structuredClone(this.filters)
            filtersWithSearch.search = this.search
            return filtersWithSearch
        },
    },
}
</script>

<style scoped>
.total-by-year {
    color: #3c47d1;
}
.data-center{
    text-align: center;
}
.production{
    background-color: #eeeeee;
}
.total{
    color: #3c47d1 !important;
}
tr.total[key^="total-"] {
    color: #3c47d1;
}
tr.total {
    color: #3c47d1 !important;
}
div.v-item-group.theme--light.v-expansion-panels.v-expansion-panels--accordion.v-expansion-panels--flat > div > button{
   padding-left: 0px !important;
   padding-right: 0px !important;
}
a{
    color: #0000EE;
    text-decoration: underline;
}
</style>

